import { render } from "./App.vue?vue&type=template&id=2a8b2114&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2a8b2114&lang=scss"

import exportComponent from "C:\\xampp2\\htdocs\\freelance\\act\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__